import { ActionIcon, Tooltip } from '@mantine/core';
import { IconDirections, IconPrinter } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { BlurhashCanvas } from 'src/Components/BlurhashCanvas';
import { ImagePlaceholder } from 'src/Components/Shared/ImagePlaceholder';

import styles from './InstructionCard.module.scss';
import { Props } from './InstructionCard.types';

const InstructionCard = ({
  content,
  title,
  imageUrl,
  onClick,
  onPrintClick,
  isPrintLoading,
  blurhash,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.titleRow}>
        <div className={styles.title}>{title}</div>
        {onPrintClick && (
          <Tooltip label={t('instructions.card.print', 'Imprimer la consigne')} withArrow>
            <ActionIcon
              variant="subtle"
              size="md"
              loading={isPrintLoading}
              onClick={e => {
                e.stopPropagation();
                onPrintClick(e);
              }}
              aria-label={t('instructions.card.print', 'Imprimer la consigne')}
            >
              <IconPrinter size={18} className={styles.printIcon} />
            </ActionIcon>
          </Tooltip>
        )}
      </div>
      <div className={styles.imageContainer}>
        {imageUrl ? (
          <>
            {blurhash && (
              <div className={styles.blurhashBackground}>
                <BlurhashCanvas blurhash={blurhash} width={32} height={32} />
              </div>
            )}
            <img src={imageUrl} className={styles.image} alt={title} />
          </>
        ) : (
          <ImagePlaceholder Icon={IconDirections} height={127} iconSize={60} />
        )}
      </div>
      <div className={styles.content}>{content}</div>
    </div>
  );
};

export default InstructionCard;
